module.exports = __webpack_public_path__ + "img/cycle.e6c9c12e.png";